import React from "react";
import { Row, Col, Typography, Empty } from "antd";
import CompareCMP from "./components/Compare";

const { Title } = Typography;

function Compare() {
  return (
    <div className="flex-grow flex flex-col p-5">
      <div className="flex-grow flex flex-col lg:flex-row space-x-0 lg:space-x-4 space-y-4 lg:space-y-0">
        <div className="flex-grow">
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <Title level={2}>Compare</Title>
              <CompareCMP />
            </Col>
          </Row>
        </div>
        <div className="flex-shrink-0 w-full lg:w-4/12">
          <Title level={2}>Reports</Title>
          <div className="bg-white border border-gray-200 rounded-md p-5 flex-grow">
            <Empty />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Compare;
